module.exports = "/images/no-avatar.png?5034483a52944de080d0cea3e4f9e504";